"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pagina = _interopRequireDefault(require("./pagina"));
var _popup = _interopRequireDefault(require("./popup"));
var _constantes = _interopRequireDefault(require("./constantes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  Pagina: _pagina["default"],
  Popup: _popup["default"],
  Constantes: _constantes["default"]
};
exports["default"] = _default;